  export default new Proxy({}, {
    get(_, key) {
      throw new Error(`Module "string_decoder" has been externalized for browser compatibility. Cannot access "string_decoder.${key}" in client code.  See https://vite.dev/guide/troubleshooting.html#module-externalized-for-browser-compatibility for more details.`)
    }
  })